export default __webpack_public_path__ + "assets/1eb7cbd2d92ec6d839e122ffc59a9d40.jpg";